import { http } from "@/api/client";
import type { ApiItemResponse, MockDatabase } from "@/api/types";
import { sessionApi } from "@/api/session";
import { gamesApi } from "@/api/games";
import { packagesApi } from "@/api/packages";
import { contentApi } from "@/api/content";
import { shareConfigsApi } from "@/api/share-configs";
import { shareRecordsApi, analyticsApi, sdkApi, adminApi } from "@/api/analytics";

/** Aggregated API surface for pages and loaders. */
export const api = {
  bootstrap: () => http.get<ApiItemResponse<MockDatabase>>("/api/bootstrap"),
  putBootstrap: (data: MockDatabase) => http.put<ApiItemResponse<MockDatabase>>("/api/bootstrap", data),
  getSession: sessionApi.get,
  setRole: (role: string) => sessionApi.setRole(role),
  getMe: sessionApi.me,
  listGames: gamesApi.list,
  createGame: gamesApi.create,
  getGame: gamesApi.get,
  updateGame: gamesApi.update,
  deleteGame: gamesApi.remove,
  listPackages: packagesApi.list,
  createPackage: packagesApi.create,
  getPackage: packagesApi.get,
  updatePackage: packagesApi.update,
  deletePackage: packagesApi.remove,
  listShareConfigs: shareConfigsApi.list,
  createShareConfig: shareConfigsApi.create,
  updateShareConfig: shareConfigsApi.update,
  listLandingPages: contentApi.listLandingPages,
  publishLandingPage: contentApi.publishLandingPage,
  listShareRecords: shareRecordsApi.list,
  analyticsOverview: analyticsApi.overview,
  sdkMonitor: sdkApi.monitor,
  platformHealth: adminApi.platformHealth,
};

export {
  sessionApi,
  gamesApi,
  packagesApi,
  contentApi,
  shareConfigsApi,
  shareRecordsApi,
  analyticsApi,
  sdkApi,
  adminApi,
};

export { ApiError, request, http } from "@/api/client";
